import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import TerminalIcon from "@mui/icons-material/Terminal";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { pages } from "../common/Data"; // Importing pages from Data file
const Navbar = () => {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <AppBar
      position="sticky"
      sx={{ backgroundColor: "white", top: 0, zIndex: 1100 }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ width: "100%", alignContent: "center" }}>
          <TerminalIcon
            sx={{ display: { color: "black", xs: "none", md: "flex" }, mr: 1 }}
          />
          <Typography
            variant="h4"
            noWrap
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontWeight: 700,
              letterSpacing: ".3rem",
              background: "#000000",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              color: "transparent",
              cursor: "pointer",
              transition: "color 0.2s",
              ":hover": {
                color: "black",
              },
            }}
          >
            VIVEK RATHI
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              gap: 10,
            }}
          >
            {pages.map((page) => (
              <Button
                key={page.label}
                onClick={() => handleScroll(page.route.replace("/", ""))}
                sx={{
                  fontWeight: 700,
                  color: "black",
                  background: "inherit",
                  display: "block",
                  borderRadius: "15px",
                  ":hover": {
                    borderRadius: "15px",
                    color: "white",
                    backgroundColor: "black",
                  },
                }}
              >
                {page.label}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Tooltip title="GitHub">
                <IconButton
                  component="a"
                  href="https://github.com/streamvk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ ml: 1, color: "black" }}
                >
                  <GitHubIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="LinkedIn">
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/in/vivek-rathi-uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ ml: 1, color: "black" }}
                >
                  <LinkedInIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
